import React, { useState, useContext } from 'react';
import NavBar from '../components/NavBar';
import SubscriptionForm from '../components/SubscriptionForm';
import ArrowNavigation from '../components/ArrowNavigation';
import NeedsContentDisplay from '../components/NeedsContentDisplay';
import PageDots from '../components/PageDots';
import { useAboutPages } from '../components/aboutpage';
import { LanguageContext } from '../LanguageContext';
import '../App.css';

function About() {
  const { t } = useContext(LanguageContext);
  const [currentPage, setCurrentPage] = useState(0);
  const pages = useAboutPages();

  const goToNextPage = () => {
    setCurrentPage((prevPage) => (prevPage + 1) % pages.length);
  };

  const goToPreviousPage = () => {
    setCurrentPage((prevPage) => (prevPage - 1 + pages.length) % pages.length);
  };

  if (pages.length === 0) {
    return <div className="container">Loading...</div>;
  }

  return (
    <div>
      <NavBar />
      <div className="container">
        <ArrowNavigation
          goToPreviousPage={goToPreviousPage}
          goToNextPage={goToNextPage}
          currentPage={currentPage}
          pages={pages}
        />
        <NeedsContentDisplay content={pages[currentPage]} />
        <PageDots currentPage={currentPage} totalPages={pages.length} />
        <br />
      </div>
      {/* <SubscriptionForm /> */}
    </div>
  );
}

export default About;
